
















































































import Vue from 'vue';
import slugify from 'slugify';
import LoadingModal from '@/common/components/LoadingModal.vue';
import api from '@/common/api';
import { BasicProcessor, Processor } from '@/common/types/processors.types';
import { initValidationErrors, ValidationErrors } from '@/common/validation/validation.types';
import { PaymentType } from '@/common/types/payments.types';
import { initDefaultHppConfig, HppColumn, HppField } from '@/common/util/hostedPaymentPages.util';
import { JsonApiArrayResponse } from '@/jsonApi.types';
import { CustomField, CustomFieldType, InfoField } from '@/common/components/support/support.types';
import { nanoid } from 'nanoid';
import { HostedPaymentPageTypes } from '@/common/types/hostedPaymentPages.types';
import ProcessorSelector from '../components/hosted-payments/ProcessorSelector.vue';
import HostedPaymentAmount from '../components/hosted-payments/HostedPaymentAmount.vue';
import { Plan } from '../plans/plans.types';

export default Vue.extend({
  props: {},
  data() {
    return {
      PaymentType,
      HostedPaymentPageTypes,
      hppWriteModel: {
        name: '',
        description: '',
        redirect: null,
        achProcessorId: '',
        creditCardProcessorId: '',
        amount: 0,
        isFixedAmount: false,
        config: initDefaultHppConfig(),
        slug: '',
        isRecurring: false,
        planId: null,
      },
      isSubmitting: false as boolean,
      showModal: false as boolean,
      availableProcessors: [] as BasicProcessor[],
      availablePlans: [] as Plan[],
      selectedProcessor: null as Processor | null,
      validationErrors: initValidationErrors() as ValidationErrors,
      chosenHppType: '' as string,
      hppPaymentTypes: [
        {
          display: HostedPaymentPageTypes.STANDARD,
          value: HostedPaymentPageTypes.STANDARD,
        },
        {
          display: HostedPaymentPageTypes.RECURRING,
          value: HostedPaymentPageTypes.RECURRING,
        },
        {
          display: HostedPaymentPageTypes.FIXED_AMOUNT,
          value: HostedPaymentPageTypes.FIXED_AMOUNT,
        },
      ],
      infoFields: [] as any[],
      billingFields: [] as any[],
      billingRequiredFields: [] as any[],
      shippingFields: [] as any[],
      shippingRequiredFields: [] as any[],
      paymentFields: [] as any[],
      paymentRequiredFields: [] as any[],
    };
  },
  mounted() {
    this.getCustomerInfoFields();
    console.log('this.infoFields', this.infoFields);
    this.loadAvailableProcessors();
    this.loadCustomFields();
    this.loadAvailablePlans();
  },
  methods: {
    loadAvailableProcessors() {
      if (this.showModal) {
        this.submitActions(true);
      }
      api
        .get('processors')
        .then(this.setAvailableProcessors)
        .catch(this.handleError)
        .finally(() => this.submitActions(false));
    },
    setFixedAmount(fixedAmount: number) {
      this.hppWriteModel.amount = fixedAmount;
    },
    loadCustomFields() {
      api
        .get('/custom-fields', {
          params: {
            hpp: true,
          },
        })
        .then(this.assignCustomFields);
    },
    loadAvailablePlans() {
      api
        .get('/plans')
        .then(this.setAvailablePlans);
    },
    assignCustomFields({ data }: { data: JsonApiArrayResponse<CustomField> }) {
      if (data.data!.length > 0) {
        const fields: CustomField[] = data.data!;
        const customFieldsColumnFields: HppField[] = fields.map((field: CustomField) => ({
          id: field.id,
          type: this.getCustomFieldType(field.type),
          name: field.name,
          value: this.getCustomFieldType(field.type) === 'VCheckbox' ? false : '',
          display: field.type,
          required: field.required,
          attributes: {
            label: (this.$options.filters as any).capitalize(field.name),
            items: field.options.map((option) => option.value),
          },
          customField: true,
          hidden: false,
          style: '',
        }));

        customFieldsColumnFields.unshift({
          id: nanoid(),
          type: 'HppHeading',
          attributes: {
            label: 'Additional Information',
          },
          name: 'additionalFieldsHeading',
          value: 'Additional Information',
          required: false,
          customField: false,
          hidden: false,
          style: 'grid-column-start: 1; grid-column-end: 3',
        });

        const customFieldsColumn: HppColumn = {
          key: nanoid(),
          type: 'Column',
          name: 'additionalFields',
          fields: customFieldsColumnFields,
        };
        const previousToLast = this.hppWriteModel.config[0].columns.length - 1;
        this.hppWriteModel.config[0].columns.splice(previousToLast, 0, customFieldsColumn);
      }
    },
    getCustomFieldType(customFieldType: CustomFieldType) {
      if (customFieldType === CustomFieldType.TEXT) {
        return 'VTextField';
      }
      if (customFieldType === CustomFieldType.CHECK) {
        return 'VCheckbox';
      }

      return 'VSelect';
    },
    sluggifyForSubdomain(value: string): any {
      this.hppWriteModel.slug = slugify(value, {
        lower: true,
        strict: true,
      });
    },
    handleError() {
      this.$toasted.error('There was a problem loading available processors');
    },
    setAvailableProcessors({ data: { data } }: { data: { data: BasicProcessor[] } }) {
      this.availableProcessors = data;
    },
    setAvailablePlans({ data: { data } }: { data: { data: any } }) {
      this.availablePlans = data;
    },
    submitActions(isSubmitting: boolean) {
      this.isSubmitting = isSubmitting;
    },
    reset() {
      this.selectedProcessor = null;
    },
    show() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
      this.reset();
    },
    onCreated() {
      this.$emit('created');
      this.close();
    },
    saveHpp() {
      if (!this.isValid) {
        return;
      }
      console.log('this.shippingFields', this.shippingFields);
      // this.submitActions(true);
      // this.setChosenHppTypeWrite();

      const cols = this.hppWriteModel.config[0].columns;
      Object.keys(cols).forEach((key: any) => {
        const colArr = cols[key];
        if (['billingAddress', 'shippingAddress', 'paymentFields'].includes(colArr.name)) {
          let fieldCat = '';
          if (colArr.name === 'billingAddress') {
            fieldCat = 'Billing';
          } else if (colArr.name === 'shippingAddress') {
            fieldCat = 'Shipping';
          } else {
            fieldCat = 'Payment';
          }

          Object.keys(colArr.fields).forEach((fieldKey: any) => {
            // Makes the "Use different shipping information" (i.e. "HppEnableButton") button invisible if no Shipping
            // Customer Information Fields are enabled for HPP
            if (this.hppWriteModel.config[0].columns[key].fields[fieldKey].name === 'shippingEnabled' && this.shippingFields.length === 0) {
              this.hppWriteModel.config[0].columns[key].fields[fieldKey].hidden = true;
            }
            if (!['billingHeading', 'shippingHeading', 'shippingEnabled'].includes(colArr.fields[fieldKey].name)) {
              if (!this.isVisible(colArr.fields[fieldKey].name, fieldCat)) {
                this.hppWriteModel.config[0].columns[key].fields[fieldKey].hidden = true;
              } else {
                this.hppWriteModel.config[0].columns[key].fields[fieldKey].hidden = false;
              }

              if (this.isRequired(colArr.fields[fieldKey].name, fieldCat)) {
                this.hppWriteModel.config[0].columns[key].fields[fieldKey].required = true;
              } else {
                this.hppWriteModel.config[0].columns[key].fields[fieldKey].required = false;
              }
            }
          });
        }
      });

      api
        .post('/hosted-payments', this.hppWriteModel)
        .then(this.showSuccess)
        .catch(this.handleSaveError);
    },
    showSuccess(response: any) {
      const hppId = response.data.data.id;
      window.location.assign(`/hosted-payments/${hppId}/edit`);
    },
    handleSaveError({ response }: { response: any }) {
      this.submitActions(false);
      if (response.status === 422) {
        const errors = response?.data?.errors;
        let msg: any = '';
        Object.keys(errors).forEach((key: any, idx: any) => {
          if (idx > 0) msg += '<br />';
          msg += `${errors[key]}`;
        });
        this.$toasted.error(msg);
      } else {
        this.$toasted.error(`There was a problem creating the Hosted Payment Page. (${response.status})`);
      }

      this.validationErrors = response.data.errors || {};
    },
    setChosenHppTypeWrite() {
      if (this.hppWriteModel.planId !== null) {
        this.hppWriteModel.isRecurring = true;
      }
      if (this.chosenHppType === HostedPaymentPageTypes.STANDARD) {
        this.hppWriteModel.isFixedAmount = false;
        this.hppWriteModel.isRecurring = false;
      } if (this.chosenHppType === HostedPaymentPageTypes.FIXED_AMOUNT) {
        this.hppWriteModel.isRecurring = false;
        this.hppWriteModel.isFixedAmount = true;
      } if (this.chosenHppType === HostedPaymentPageTypes.RECURRING) {
        this.hppWriteModel.isFixedAmount = false;
        this.hppWriteModel.isRecurring = true;
      }
    },
    getFieldName(name: string, removeName: string) {
      const fieldName = name.replace(removeName, '').replace(/ /g, '');
      return (fieldName.charAt(0).toLowerCase() + fieldName.slice(1));
    },
    isVisible(fieldName: string, fieldType: string) {
      return ((fieldType === 'Billing' && this.billingFields.includes(fieldName))
        || (fieldType === 'Shipping' && this.shippingFields.includes(fieldName))
        || (fieldType === 'Payment' && this.paymentFields.includes(fieldName)));
    },
    isRequired(fieldName: string, fieldType: string) {
      return ((fieldType === 'Billing' && this.billingRequiredFields.includes(fieldName))
        || (fieldType === 'Shipping' && this.shippingRequiredFields.includes(fieldName))
        || (fieldType === 'Payment' && this.paymentRequiredFields.includes(fieldName)));
    },
    getCustomerInfoFields() {
      api
        .get('/info-fields', {
          params: {
            hpp: true,
          },
        })
        .then(this.assignCustomerInfoFields);
    },
    assignCustomerInfoFields({ data }: { data: JsonApiArrayResponse<InfoField> }) {
      this.infoFields = data.data!;
      Object.keys(this.infoFields).forEach((key: any) => {
        const field = this.infoFields[key] as InfoField;
        const fieldName = this.getFieldName(field.name, field.category);
        if (field.category === 'Billing') {
          this.billingFields.push(fieldName);
          if (field.required) {
            this.billingRequiredFields.push(fieldName);
          }
        } else if (field.category === 'Shipping') {
          this.shippingFields.push(fieldName);
          if (field.required) {
            this.shippingRequiredFields.push(fieldName);
          }
        } else if (field.category === 'Payment') {
          this.paymentFields.push(fieldName);
          if (field.required) {
            this.paymentRequiredFields.push(fieldName);
          }
        }
      });
    },
  },
  computed: {
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
    hppUrl(): string {
      return `${window.location.origin}/pay/`;
    },
    planDescription(): string {
      if (this.hppWriteModel.planId) {
        const plan = this.availablePlans.find((p) => p.id === this.hppWriteModel.planId);
        return `$${plan?.amount! / 100} ${plan?.recurrenceText}`;
      }
      return '';
    },
  },
  components: {
    LoadingModal,
    ProcessorSelector,
    HostedPaymentAmount,
  },
});
